import * as Yup from "yup";
import { SelectOption } from "./AddUser.types";

// Single source of truth for which role name means "standard user" — used
// both by the validation schema below and by AddUserForm to decide whether
// to show the Assign Clients section at all.
export const STANDARD_USER_ROLE_NAME = "Standard User";

export const addUserValidationSchema = Yup.object({
  firstName: Yup.string()
    .trim()
    .required("First name is required")
    .matches(/^[A-Za-z ]+$/, "Only alphabets allowed")
    .min(2, "Minimum 2 characters")
    .max(50, "Maximum 50 characters"),

  lastName: Yup.string()
    .trim()
    .required("Last name is required")
    .matches(/^[A-Za-z ]+$/, "Only alphabets allowed")
    .min(2, "Minimum 2 characters")
    .max(50, "Maximum 50 characters"),

  email: Yup.string()
    .email("Invalid email format")
    .required("Email is required"),

  role: Yup.string().required("Role selection is required"),

  // Array of client ids, not a single string — client is a multi-assign field.
  client: Yup.array().of(Yup.string()).when("role", {
    is: STANDARD_USER_ROLE_NAME,
    then: (schema) =>
      schema.min(1, "At least one client must be assigned").required(),
    otherwise: (schema) => schema.notRequired(),
  }),
});

export const addUserInitialValues = {
  firstName: "",
  lastName: "",
  email: "",
  role: "",
  client: [] as string[],
};

// Fallback options if a page renders AddUserForm without fetching real
// roles/clients (e.g. RBAC config hasn't loaded yet).
export const defaultRoleOptions: SelectOption[] = [
  { label: "Admin", value: "Admin" },
  { label: "Standard User", value: "Standard User" },
];

export const defaultClientOptions: SelectOption[] = [];
